<template>
  <ul class="l-side-partners">
    <ListItemRoom
      v-for="project in filteredProjects"
      :key="project.id"
      :partner="project.partner"
      :project="project"
    />
  </ul>
</template>

<script>
import ListItemRoom from '@/components/side/ListItemRoom';

export default {
  props: {
    search: {
      type: String,
      required: true
    }
  },
  components: {
    ListItemRoom
  },
  computed: {
    filteredProjects() {
      // ルーム名もしくはパートナー名に、検索キーワードが含まれるルームを返す
      const projects = this.projects;
      const search = this.search;
      if (!search && search !== 0) {
        return projects;
      }
      let results = projects.filter(project => {
        if (
          project.name.indexOf(search) !== -1 ||
          project.partner.name.indexOf(search) !== -1
        ) {
          return true;
        }
      });
      return results;
    },
    projects() {
      return this.$store.state.projects;
    }
  }
};
</script>
